import { Injectable } from '@angular/core';
import { AccountService } from "app/account/account.service";

@Injectable()
export class JWTService {

  constructor(private _accountService: AccountService) { }

  checkToken() {
    if (localStorage.getItem("token") && localStorage.getItem("user")) {
      this._accountService.updateAccount(JSON.parse(localStorage.getItem("user")));
      this._accountService.updateAuthToken(localStorage.getItem("token"));
    } else {
      return false;
    }
    if (this._accountService.authToken.getValue() && this._accountService.authToken.getValue() !== "Empty") {
      const token = this._accountService.authToken.getValue().split(".")[1];
      const userInfo = JSON.parse(atob(token));
      if (new Date(userInfo.ExpirationTime).getTime() < new Date().getTime()) {
        return false;
      } else {
        return true;
      }
    }
    

  }
}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/webservice/jwt.service.ts